import { EntitiesStructure } from 'common/types/Page'
import { DiagnosticFinding, DiagnosticRule } from '../types'

export const deviceOnlyRule: DiagnosticRule = {
  id: 'device-only',
  name: 'Device-Only Visibility',
  run: (entities: EntitiesStructure): DiagnosticFinding[] => {
    const findings: DiagnosticFinding[] = []

    for (const entity of Object.values(entities)) {
      const appearance = 'appearance' in entity && entity.appearance
      if (!appearance) {
        continue
      }

      let hiddenOn: 'mobile' | 'desktop' | null = null
      if (appearance.desktop === true && appearance.mobile === false) {
        hiddenOn = 'mobile'
      } else if (appearance.desktop === false && appearance.mobile === true) {
        hiddenOn = 'desktop'
      }

      if (hiddenOn) {
        const visibleOn = hiddenOn === 'mobile' ? 'desktop' : 'mobile'
        findings.push({
          ruleId: 'device-only',
          severity: 'info',
          entityId: entity.id,
          entityType: entity.type,
          message: `${entity.type} is hidden on ${hiddenOn} (${visibleOn} only)`,
          metadata: { hiddenOn },
        })
      }
    }

    return findings
  },
}
